import { v4 as uuidv4 } from "uuid";
export class OrganizationModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.emailAddress = "";
        this.contactPerson = "";
        this.statesCount = 0;
    }
}
export default class Organization extends OrganizationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
